<template>
<div id="settings" class="w-full">

  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

    <!-- technic -->
    <vs-tab icon-pack="feather" icon="icon-cpu" :label="!isSmallerScreen ? 'Teknik Servis' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <technic-settings />
      </div>
    </vs-tab>
 
  </vs-tabs>
</div>
</template>

<script>
import technicSettings from "./technicSettings.vue"

export default {
  components: {
    technicSettings,
    
  },
  data() {
    return {

    }
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768
    }
  }
}
</script>

<style lang="scss" scoped>
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
#settings{
  .con-slot-tabs{
    width: 100%;
  }

}
</style>
